(function () {
  var STORAGE_KEY = 'promo_timer_end';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initTimer() {
    var el = document.getElementById('promo-countdown');
    if (!el) return;

    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 20;
    var durationMs = minutes * 60 * 1000;

    var stored = sessionStorage.getItem(STORAGE_KEY);
    var endTime = stored ? parseInt(stored, 10) : null;

    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + durationMs;
      sessionStorage.setItem(STORAGE_KEY, endTime);
    }

    function tick() {
      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        endTime = Date.now() + durationMs;
        sessionStorage.setItem(STORAGE_KEY, endTime);
        remaining = durationMs;
      }

      var totalSecs = Math.floor(remaining / 1000);
      var m = Math.floor(totalSecs / 60);
      var s = totalSecs % 60;
      el.textContent = pad(m) + ':' + pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimer);
  } else {
    initTimer();
  }
})();
